<template>
    <div class="agent-links mx-auto">
        <b-container class="mb-5">
            <b-card class="bg-white vh-100">
                <h2 class="text-center"></h2>

                <b-breadcrumb class="bg-white">
                    <b-breadcrumb-item href="#"> Home</b-breadcrumb-item>
                    <b-breadcrumb-item active href="#">Agent Resources</b-breadcrumb-item>
                </b-breadcrumb>

                <div class="row">
                    <!-- Left col -->
                    <div class="col-md-12">
                            <div class="card-body p-0">
                                <!--Links-->
                                <div class="card scroll m-1 mb-2">
                                    <div class="card-header">
                                        <h3 class="card-title text-center">Links</h3>
                                        <div class="card-tools">
                                            <template v-if="this.is_admin">
                                                <button id="create-resource-links" type="button" class="btn btn-tool" @click="toggleCreate">
                                                    <i class="fas fa-plus"></i>
                                                </button>
                                                <b-tooltip target="create-resource-links" triggers="hover">
                                                    Create New Link
                                                </b-tooltip>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table m-0">
                                            <tbody>
                                            <tr v-for="link in this.links">
                                                <td>
                                                    <a :href="link.link" target="_blank" style="color:black">
                                                        <i class="fa fa-globe" style="color:black"></i>&nbsp; {{
                                                            link.name
                                                        }}
                                                    </a>
                                                </td>
                                                <td v-if="is_admin">
                                                    <button id="delete-resource-links" type="button" class="btn btn-tool float-right" @click="deleteResource(link, 'ResourceLink')">
                                                        <i class="fas fa-trash-alt fa-lg hover" v-b-tooltip.hover
                                                           title="Delete"></i>
                                                    </button>
                                                    <b-tooltip target="delete-resource-links" triggers="hover">
                                                        Delete
                                                    </b-tooltip>
                                                    <button id="edit-resource-links" type="button" class="btn btn-tool float-right" @click="editLink(link)">
                                                        <i class="fas fa-pencil-alt fa-lg hover" v-b-tooltip.hover
                                                           title="Edit"></i>
                                                    </button>
                                                    <b-tooltip target="edit-resource-links" triggers="hover">
                                                        Edit
                                                    </b-tooltip>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!--Documents-->
                                <div class="card scroll m-1 mb-2">
                                    <div class="card-header">
                                        <h3 class="card-title text-center">Documents</h3>
                                        <div class="card-tools">
                                            <template v-if="this.is_admin">
                                                <button id="create-document" type="button" class="btn btn-tool" @click="toggleCreate">
                                                    <i class="fas fa-plus"></i>
                                                </button>
                                                <b-tooltip target="create-document" triggers="hover">
                                                    Create New Documents
                                                </b-tooltip>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table m-0">
                                            <tbody>
                                            <tr v-for="document in this.documents">
                                                <td>
                                                    <a :href="asset(document.path)" target="_blank"
                                                       style="color:black"><i class="fa fa-folder-open"
                                                                              style="color:black"></i>&nbsp;
                                                        {{ document.name }} </a>
                                                </td>
                                                <td v-if="is_admin">
                                                    <button id="delete-resource-documents" type="button" class="btn btn-tool float-right" @click="deleteResource(document, 'ResourceDocument')">
                                                        <i class="fas fa-trash-alt fa-lg hover" v-b-tooltip.hover
                                                           title="Delete"></i>
                                                    </button>
                                                    <b-tooltip target="edit-resource-documents" triggers="hover">
                                                        Delete
                                                    </b-tooltip>
                                                    <button id="edit-resource-documents" type="button" class="btn btn-tool float-right" @click="editDocument(document)">
                                                        <i class="fas fa-pencil-alt fa-lg hover"></i>
                                                    </button>
                                                    <b-tooltip target="edit-resource-documents" triggers="hover">
                                                        Edit
                                                    </b-tooltip>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!--Events-->
                                <div class="card scroll m-1 mb-2">
                                    <div class="card-header">
                                        <h3 class="card-title text-center">Upcoming Events</h3>
                                        <div class="card-tools">
                                            <template v-if="is_admin">
                                                <button id="create-event" type="button" class="btn btn-tool" @click="toggleCreate">
                                                    <i class="fas fa-plus"></i>
                                                </button>
                                                <b-tooltip target="create-event" triggers="hover">
                                                    Create New Events
                                                </b-tooltip>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table m-0">
                                            <tbody>
                                            <tr v-for="event in this.events">
                                                <td>
                                                    <i class="fa fa-calendar-day" style="color:black"></i> {{
                                                        event.name
                                                    }} at
                                                    {{ formatDate(event.event_date) }}
                                                </td>
                                                <td v-if="this.is_admin">
                                                    <button id="delete-events" type="button" class="btn btn-tool float-right" @click="deleteResource(event, 'TeamEvent')">
                                                        <i class="fas fa-trash-alt fa-lg hover" v-b-tooltip.hover
                                                       title="Delete"></i>
                                                    </button>
                                                    <b-tooltip target="delete-events" triggers="hover">
                                                        Delete
                                                    </b-tooltip>
                                                    <button id="edit-events" type="button" class="btn btn-tool float-right" @click="editEvent(event)">
                                                        <i class="fas fa-pencil-alt fa-lg hover" v-b-tooltip.hover
                                                           title="Edit"></i>
                                                    </button>
                                                    <b-tooltip target="edit-events" triggers="hover">
                                                        Edit
                                                    </b-tooltip>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </b-card>
        </b-container>
        <b-modal id="createResourceModal" ref="createResourceModal" title="Create New" size="lg">
            <create-resource-link ref="createResourceLink"></create-resource-link>
            <div slot="modal-footer" class="w-100"></div>
        </b-modal>
        <b-modal id="editResourceModal" ref="editResourceModal" title="Edit" size="lg">
            <edit-resource-link ref="editResourceLink" :resource="this.resource" :type="this.type"></edit-resource-link>
            <div slot="modal-footer" class="w-100"></div>
        </b-modal>
        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>

import moment from 'moment'

export default {
    name: 'agent-links',
    props: {
        editing: Boolean,
        default: false

    },
    beforeMount() {
        this.getAdmin();
    },
    created() {
        this.getLinks();
        this.getEvents();
        this.getDocuments();
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
    data() {
        return {
            is_admin: false,
            window: {
                width: 0,
                height: 0
            },
            isLoading: false,
            links: [],
            events: [],
            documents: [],
            resource: null,
            type: null,
            // editing: false,
            breadcrumb_items: [
                {
                    'text': 'Home',
                    'href': "/"
                },
                {
                    'text': "Agent Resources",
                    'href': "#"
                },
            ],
        }
    },
    methods: {
        getAdmin(){
            let _self = this;
            let promise = axios.get('/api/admincheck');

            return promise.then((response) => {

                _self.is_admin = response.data;
            });
        },
        asset(path) {
            var base_path = window._asset || '';
            return base_path + path;
        },
        toast(message, variant){
            this.$bvToast.toast(message, {
                title: variant,
                variant: variant,
                solid: true
            })
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        editLink(resource) {
            this.resource = resource;
            this.type = "ResourceLink";
            this.$refs['editResourceModal'].show();
        },
        editDocument(resource) {
            this.resource = resource;
            this.type = "ResourceDocument";
            this.$refs['editResourceModal'].show();
        },
        editEvent(resource) {
            this.resource = resource;
            this.type = "TeamEvent";
            this.$refs['editResourceModal'].show();
        },
        getLinks() {
            let _self = this;
            let promise = axios.get('/api/resource-links');

            return promise.then((response) => {

                _self.links = response.data;
            });
        },
        getDocuments() {
            let _self = this;
            let promise = axios.get('/api/resource-documents');

            return promise.then((response) => {

                _self.documents = response.data;
            });
        },
        getEvents() {
            let _self = this;
            let promise = axios.get('/api/team-events');

            return promise.then((response) => {

                _self.events = response.data;
            });
        },
        toggleCreate() {
            this.$refs['createResourceModal'].show();
        },
        toggleEdit() {
            this.editing = !this.editing;
        },
        deleteResource(item, type) {
            let _self = this;
            if (confirm("Really delete?")) {
                _self.isLoading = true;
                axios.delete('/api/resource-link/' + type + "/" + item.id).then(function (response) {
                    _self.isLoading = false;
                    console.log(response.data.status)
                    if (response.data.status === false) {
                        _self.toast('Unable to delete resource, please try again', 'error');
                    } else {
                        _self.toast('Resource has been deleted', 'success');
                        window.location.reload();
                    }
                });
            }
        },
        resourceUpdated() {
            this.$refs['editResourceModal'].hide();
            this.toast('Resource has been updated!','success');
        },
        resourceCreated() {
            this.$refs['createResourceModal'].hide();
            this.toast('Resource has been created!','success');
            window.location.reload();
        },
        formatDate(date){ //TODO make these vue filters
            return moment(String(date)).format('MM/DD/YYYY h:mm:ss')
        },
        formatTime(date){
            return moment(String(date)).format('h:mm:ss')
        }
    },
    computed: {
        window_width() {
            return this.window.width;
        },
    },
    mounted () {
        this.$eventHub.$on('resource::updated', this.resourceUpdated);
        this.$eventHub.$on('resource::created', this.resourceCreated);
    },
}
</script>

<style lang="scss">
.a {
    color: white;
}

.top-right {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 2;
    padding: 5px;

    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 667px)
    {
        right: 5px;
    }
}

.scroll {
    min-height: 200px;
    max-height: 400px;
    overflow-y: auto;
}

</style>
